import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
type Props = {
  component?: 'span' | 'h2';
  children: string | string[];
};
export function ProductCardTypography(t0) {
  const $ = _c(4);
  const {
    children,
    component: t1
  } = t0;
  const component = t1 === undefined ? "span" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "primary.main",
      textTransform: "uppercase",
      letterSpacing: "0.6px",
      lineHeight: "150%"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children || $[2] !== component) {
    t3 = <Typography variant="accent" component={component} sx={t2}>{children}</Typography>;
    $[1] = children;
    $[2] = component;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}